import { computed, unref, type MaybeRef } from "vue";
import { createQuery } from "@/queries";
import { getRecommendationsBanners, type Audience } from "@/features/recommendations/api/recommendations";
import type { AxiosResponse } from "axios";
import type { RecommendedBannersResponse } from "@/types/BannersTypes";

type RecommendationsBannersResponse = Awaited<
  ReturnType<typeof getRecommendationsBanners>
> extends AxiosResponse<infer T>
  ? T
  : never;

export const useRecommendationsBannersQuery = (audience: MaybeRef<Audience>) => {
  return createQuery<RecommendationsBannersResponse>({
    key: computed(() => ["recommendations", "banners", unref(audience)]),
    fetcher: async () => {
      const response = await getRecommendationsBanners(unref(audience));
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

